import { UserProvider } from '@auth0/nextjs-auth0';
import '@fullcalendar/common/main.css';
import '@fullcalendar/timegrid/main.css';
import { ThemeProvider } from '@material-tailwind/react';
import React, { useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import ReactGA from 'react-ga4';
import { SWRConfig } from 'swr';
import ErrorBoundary from '../components/shared/errorBoundary';
import { LoadingContext } from '../utils/contexts/loadingContext';
import '../utils/styles/globals.css';
import { AppPropsWithLayout, Loading } from '../utils/types';

function MyApp({ Component, pageProps }: AppPropsWithLayout<unknown>) {
  const [loading, setLoading] = useState<Loading>();

  const getLayout = Component.getLayout ?? ((page) => page);

  //Google analytics
  const trackingId = 'G-KPM6MQLPZT';
  ReactGA.initialize(trackingId);

  return (
    <>
      <ErrorBoundary>
        <ThemeProvider>
          <LoadingContext.Provider value={{ loading, setLoading }}>
            <UserProvider>
              {/* SWR is used for client side data fetching. This sets the global fetcher */}
              <SWRConfig
                value={{
                  fetcher: (resource, init) =>
                    fetch(resource, init).then((res) => res.json()),
                }}
              >
                {getLayout(<Component {...pageProps} />)}
              </SWRConfig>
            </UserProvider>
          </LoadingContext.Provider>
        </ThemeProvider>
      </ErrorBoundary>
    </>
  );
}

export default MyApp;
